import styled from '@emotion/styled';

import { startDirection } from 'app/styles/selectors/markup';

const S = {};

S.PasswordField = styled.div`
  label: PasswordField;

  display: flex;
  align-items: center;
`;

S.PasswordField.Button = styled.div`
  label: Button;
  
  flex: 1 0 auto;
  padding: 0.3125rem 0.375rem;
  margin-${startDirection}: 0.5rem;
  min-width: 3.125rem;
  cursor: pointer;
  text-align: center;
  text-transform: uppercase;
  color: var(--colors-silver-chalice);

  &:hover {
    color: var(--colors-scarpa-flow);
  }
`;

export default S;
